<template id="breadCrumb">
<section class="breadcrumbOuter">
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <ol class="breadcrumb">
          <li><a href="#">Home</a></li>
          <li><a href="#">Catalog</a></li>
          <li class="active">Sagami</li>
        </ol>
      </div>
    </div>
  </div>
</section>
</template>

<script>

import utils from './Utils.vue'

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'breadCrumb',
  props:['name', 'clients', 'firstamts', 'countries', 'res'],
  data () {
    return {
      reseller:{},
      token:null,
      submitted:false,
      error:{}
    }
  },
  components: {
  },
  created: function() {
  },
  methods: {
    chk: function(name, regex, errmsg) {
      // mandatory
      // if (0 == mode) {
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
//console.log('false:'+name+":"+chkval);
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    removeErr: function(evt, name) {
      console.log(name);
      delete this.error[name];
      this.$forceUpdate();
    }
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BreadCrumb.vue